// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

export class CatalogLink
{
  public id: string;
  public catalogReference: string;
  public linkCatalogEn: string;
  public linkCatalogNl: string;
  public linkCatalogRo: string;
  public linkCatalogFr: string;
  public status: string;
}
